var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHistory = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#6D6D78"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M15.714 2.41h-.366v-.855c0-.621-.49-1.119-1.092-1.119-.602 0-1.09.498-1.09 1.119v.854H5.16v-.854C5.16.934 4.67.436 4.068.436c-.602 0-1.09.498-1.09 1.119v.854h-.359C1.414 2.41.437 3.413.437 4.644v11.009c0 1.24.977 2.244 2.182 2.244h13.095c1.205 0 2.183-1.004 2.183-2.244V4.644c0-1.23-.978-2.235-2.183-2.235z",
  transform: "translate(-42 -258) translate(16 188) translate(0 52) translate(17 10) translate(9 8) translate(1.833 1.833)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.167 5.5c-2.532 0-4.584 2.052-4.584 4.583 0 2.532 2.052 4.584 4.584 4.584 2.531 0 4.583-2.052 4.583-4.584 0-2.531-2.052-4.583-4.583-4.583z",
  transform: "translate(-42 -258) translate(16 188) translate(0 52) translate(17 10) translate(9 8) translate(1.833 1.833)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.167 8.046v2.438l1.251 1.252",
  transform: "translate(-42 -258) translate(16 188) translate(0 52) translate(17 10) translate(9 8) translate(1.833 1.833)"
})))))))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHistory);
export default ForwardRef;